import { useState } from "react"
import { Box, Input } from "@chakra-ui/react"
import { Button, Text } from "@/components/ui"
import { CodeTarget } from "@/utils"

interface Props {
  userId: number;
  target: CodeTarget;
  otp: string;
  setOtp: (otp: string) => void;
  handleVerifyOtp: () => Promise<void>;
  handleResendOtp: () => Promise<void>;
  isLoading: boolean;
  isResending: boolean;
}

export const MfaComponent = ({ target, otp, setOtp, handleVerifyOtp, handleResendOtp, isLoading, isResending }: Props) => {
  const [resendSuccess, setResendSuccess] = useState(false)
  const [resendError, setResendError] = useState("")

  const onResend = async () => {
    try {
      setResendSuccess(false)
      setResendError("")
      await handleResendOtp()
      setResendSuccess(true)
    } catch {
      setResendError("Failed to resend code. Please try again.")
    }
  }

  return (
    <Box w={{ base: "92%", md: "35%" }} zIndex={1} bg="white" p={{ base: 6, md: 10 }} borderRadius={10} boxShadow="lg" minW="300px">
      <Text fontSize="xl" mb={4}>
        {target.channel === "email"
          ? `We just emailed a code to ${target.destination || "you"}`
          : target.channel === "verify" && target.destination
            ? `We just texted a code to your number ending in ${target.destination}`
            : "Enter the verification code sent to your phone"}
      </Text>
      <Input
        placeholder="6-digit code"
        value={otp}
        onChange={(e) => {
          setOtp(e.target.value)
          setResendSuccess(false)
          setResendError("")
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleVerifyOtp()
          }
        }}
        mb={4}
      />
      {resendError && <Text fontSize="sm" color="red.500" mb={2}>{resendError}</Text>}
      {resendSuccess && <Text fontSize="sm" color="green.500" mb={2}>A new code has been sent.</Text>}
      <Button variant="solid" onClick={handleVerifyOtp} loading={isLoading} w="100%" mb={3}>
        Verify Code
      </Button>
      <Text
        fontSize="sm"
        color="blue.500"
        cursor="pointer"
        textAlign="center"
        _hover={{ textDecoration: "underline" }}
        onClick={!isResending ? onResend : undefined}
      >
        {isResending ? "Sending..." : "Resend Code"}
      </Text>
    </Box>
  )
}
